// i18n
import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';

import { SyntheticEvent, useMemo } from 'react';
import styled from '@emotion/styled';
import Cookie from 'js-cookie';

import {
  spacing,
  borderRadius,
  fontSize,
  mediaMax,
} from 'presentations/views/styles';
import { blue02, gray01, gray04 } from 'presentations/views/styles/color';

import TextField from 'presentations/views/components/atoms/TextField';
import Button from 'presentations/views/components/atoms/Button';
import Checkbox from 'presentations/views/components/atoms/Checkbox';

export interface Props {
  isLoading?: boolean;
  isSubmitLoading?: boolean;
  teamName: string | null;
  isCheck: boolean | null;
  onSubmit: () => void;
  onChange: (e: SyntheticEvent<HTMLInputElement>) => void;
  viewerDomain: string | null;
}

export default function Component(props: Props) {
  const t = translateInComponent(translations);

  const referralTeamId = useMemo(() => {
    const referral = Cookie.get('referral');
    if (referral) return String(referral);
    return null;
  }, []);

  return (
    <CreateTeamContainer>
      <InputTeamNameForm>
        <StyledTextField
          name="teamName"
          value={props.teamName}
          placeholder={t('Team Name Placeholder')}
          isRequired
          label={t('Team Name')}
          description={
            <TeamNameDescription>
              {t('Team Name Description')}
            </TeamNameDescription>
          }
          isFullWidth
          isContainerFullWidth
          onChange={props.onChange}
        />
        {referralTeamId && (
          <StyledTextField
            value={referralTeamId}
            isDisabled
            isNotRequired
            label={t('Referral')}
            description={
              <TeamNameDescription>
                {t('Referral Description')}
              </TeamNameDescription>
            }
            isFullWidth
            isContainerFullWidth
          />
        )}
        {props.viewerDomain && (
          <Checkbox
            label={
              <CheckboxLabel
                dangerouslySetInnerHTML={{
                  __html: t('Auto Join Team', {
                    domain: '@' + props.viewerDomain,
                  }),
                }}
              />
            }
            isChecked={props.isCheck || false}
            name="autoJoinTeam"
            onChange={props.onChange}
          />
        )}
      </InputTeamNameForm>
      <SetUpButton
        color="primary"
        size="large"
        onClick={props.onSubmit}
        isLoading={props.isSubmitLoading}
        isDisabled={(props.teamName?.length || 0) === 0}
      >
        {t('Set up')}
      </SetUpButton>
    </CreateTeamContainer>
  );
}

const CreateTeamContainer = styled.div`
  text-align: center;
  margin-bottom: ${spacing(24)};
`;
const InputTeamNameForm = styled.div`
  width: 400px;
  padding: ${spacing(24)};
  margin-bottom: ${spacing(32)};
  background-color: ${blue02};
  border-radius: ${borderRadius(16)};
  ${mediaMax.tablet} {
    width: 100%;
  }
`;
const StyledTextField = styled(TextField)`
  margin-bottom: ${spacing(32)};
`;
const TeamNameDescription = styled.div`
  text-align: left;
  font-size: ${fontSize(14)};
`;
const CheckboxLabel = styled.span``;
const SetUpButton = styled(Button)`
  width: 160px;
`;
